import { ReactElement } from 'react'
import { Message } from '@/features/messages/shared/types'

export default function SubjectCell({ subject }: Message): ReactElement {
  return (
    <span className="c-messages-table__subject-cell">{subject}</span>
  )
}
